import WebView from "@/Layouts/WebView";
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-react";
import ProductLogo from "@/Components/ProductLogo";
import React, {Fragment, useEffect, useState} from "react";
import styles from '@/../sass/webview/components/Login.module.scss'
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import notifyNativeApp from "@/Utilities/NotifyNativeApp";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";

export default function Login() {
    const organization = usePage().props.organization;
    const preAuthorized = usePage().props?.pre_authorized ?? false;
    const accountDeletionRequested = usePage().props?.account_deletion_requested ?? false;

    const {data, setData} = useForm({
        email_or_phone: '',
        password: '',
        device_name: usePage().props.device_name,
    });

    const [state, setState] = useState({
        continueLogin: false,
        processing: false,
        errors: []
    });

    useEffect(() => {
        if (preAuthorized) {
            notifyNativeApp(preAuthorized)
        }
    }, [preAuthorized]);

    useEffect(() => {
        if (accountDeletionRequested) {
            notifyNativeApp({'account_deletion_requested': true}, 5000)
        }
    }, [accountDeletionRequested]);

    const onChange = (name, value) => {
        setData(name, value);
    };

    function checkToContinue(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            continueLogin();
        }
    }

    function continueLogin() {
        setState({...state, continueLogin: true});
    }

    const submit = (e) => {
        e.preventDefault();

        setState({...state, processing: true})
        axios.post(
            route('webview.login.store', organization.uuid),
            data
        ).then((response) => {
            let data = response.data.data;
            notifyNativeApp(data)
        }).catch((error) => {
            setState({...state, errors: error.response.data.errors, processing: false});
        })
    };

    return (
        <WebView>
            <Head>
                <title>Log in</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className={"login"}>
                <ProductLogo />
                { preAuthorized && <div className={styles.preAuthorized}>
                    <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    <span className="visually-hidden">Loading...</span>
                </div>}
                {! preAuthorized && <form onSubmit={submit}>
                    <div className="row">
                        <PhoneOrEmailInput error={state.errors["email_or_phone"]}
                                           name="email_or_phone"
                                           isFocused={true}
                                           autoComplete="username"
                                           value={data.email_or_phone}
                                           onChange={onChange}
                                           onKeyDown={(e) => checkToContinue(e)}
                                           label={i18n.t("login.email-or-phone")}
                                           className="col-12"
                                           dataQa="login-tab-choose-username"/>
                    </div>
                    {!state.continueLogin &&
                        <Fragment>
                            <Button
                                type="button"
                                onClick={() => setState({...state, continueLogin: true})}
                                className="w-100 btn btn-primary"
                            >
                                {i18n.t("login.continue")}
                            </Button>
                            <Fragment>
                                <div className={styles.or}>
                                    <hr/>
                                    <span>{i18n.t("login.or")}</span>
                                    <hr/>
                                </div>
                                <Link
                                    className="w-100 btn btn-outline-secondary"
                                    href={route('webview.join.create-account.show', organization.uuid)}
                                >
                                    {i18n.t("login.create-account")}
                                </Link>
                            </Fragment>
                        </Fragment>
                    }
                    {state.continueLogin &&
                        <Fragment>
                            <div className="row">
                                <FormInput format="password"
                                           error={state.errors["password"]}
                                           name="password"
                                           isFocused={true}
                                           autoComplete="current-password"
                                           value={data.password}
                                           onChange={onChange}
                                           label={i18n.t("login.password")}
                                           className="col-12"
                                           dataQa="login-tab-password"/>
                            </div>
                            <div className="">
                                <Button className="w-100 btn btn-primary" processing={state.processing} opacityWhileProcessing={false}>
                                    {state.processing && <Fragment>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className="visually-hidden">Loading...</span>
                                    </Fragment>}
                                    {!state.processing && i18n.t("login.log-in")}
                                </Button>
                            </div>
                        </Fragment>
                    }
                    <div className={"forgot-password-link"}>
                        <Link
                            href={route('webview.password.request', organization.uuid)}
                            className="btn btn-link text-center"
                        >
                            {i18n.t("login.forgot-password")}
                        </Link>
                    </div>
                </form>}
            </div>
        </WebView>
    )
}
